<template>
<multiselect 
    :value="value" 
    select-label=""
    :options="suggestions" 
    :custom-label="label" 
    track-by="id" 
    :loading="isLoading" 
    :placeholder="placeholder"
    :allow-empty="true"
    :optionsLimit="10"
    @input="update"
    @search-change="search">
    <slot name="noResult" slot="noResult" />
</multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
    components: { 'Multiselect': Multiselect },
    props: [ 'value', 'multiple', 'placeholder', 'label', 'filter', 'url' ],
    data () {
        return {
            suggestions: [],
            isLoading: false,
            allOptions: []
        }
    },
    created () {
        const that = this
        this.isLoading = true

        this.$api.get(this.url)
        .then(response => {
            that.allOptions = response.data

            // Show suggestions without filter if there all less than ten in total
            if (that.allOptions.length < 10) {
                that.suggestions = that.allOptions
            }

            that.isLoading = false
        })
    },
    methods: {
        search (query) {
            query = query.trim().toLowerCase()

            // Find up to 10 matching suggestions,
            // then abort for more responsive UI
            const suggestions = [ ]
            for (var i = 0; i < this.allOptions.length; i++) {
                if (this.filter(this.allOptions[i], query)) {
                    suggestions.push(this.allOptions[i])

                    if (suggestions.length >= 10) {
                        break
                    }
                }
            }

            this.suggestions = suggestions
        },
        update (value, id) {
            this.$emit('input', value)
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// multi-select.vue?127caa96